import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import styles from './NoDataAndLoading.css';

class NoDataAndLoading extends React.Component {
  render() {
    const {
      linkLabelPrefix,
      linkTarget,
      showLoadingSpinner,
      noDataToDisplay,
      title,
      description,
      footerElement,
      image,
      loadingDescription,
      loadingDescriptionAfterChangeMenu,
      linkLabel,
      linkUrl,
      halfHeight,
    } = this.props;
    let { heightClass } = this.props;
    if (!heightClass) {
      heightClass = 'full-height-no-data-display';
    }
    if (halfHeight) {
      heightClass = 'half-height-no-data-display';
    }
    return (
      <div
        className={`${
          showLoadingSpinner || noDataToDisplay
            ? `col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding ${
                styles['parent-box-data-display']
              }`
            : ''
        } `}
        id="no-data-to-display"
      >
        {showLoadingSpinner && (
          <div className={heightClass}>
            <div className={`${styles['loading-container']} box-spinner`}>
              <div className={`${styles['content-loading-spinner']}`}>
                <img
                  src={require('assets/images/loading-simple.gif')}
                  alt="mokapos spinner"
                  className={styles['loading-spinner']}
                />
                {loadingDescription !== undefined && (
                  <div className={styles.description}>
                    <p>{loadingDescription}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {loadingDescriptionAfterChangeMenu !== undefined &&
          loadingDescriptionAfterChangeMenu}
        {noDataToDisplay && !showLoadingSpinner && (
          <div className={heightClass}>
            <div className={`${styles['no-data-container']} box-spinner`}>
              <div className={`${styles['content-no-data-display']}`}>
                <div>
                  <img
                    src={image}
                    className={styles.img}
                    alt="no sales"
                    width="110px"
                  />
                </div>
                <div>
                  <h3 className={styles.title}>{title}</h3>
                </div>
                <div className={styles.description}>
                  <p>{description}</p>
                  {linkLabel && linkUrl && (
                    <p>
                      {linkLabelPrefix} &nbsp;
                      <Link
                        to={linkUrl}
                        className={styles['link-knowledge-center']}
                        onClick={this.props.onClickTrackLink}
                        target={linkTarget}
                      >
                        {linkLabel}
                      </Link>
                    </p>
                  )}
                </div>
                {!!footerElement && footerElement}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

NoDataAndLoading.propTypes = {
  showLoadingSpinner: PropTypes.bool,
  noDataToDisplay: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  footerElement: PropTypes.object,
  image: PropTypes.string,
  linkLabel: PropTypes.string,
  linkUrl: PropTypes.string,
  linkLabelPrefix: PropTypes.string,
  linkTarget: PropTypes.string,
  onClickTrackLink: PropTypes.func,
};

NoDataAndLoading.defaultProps = {
  image: require('assets/images/backoffice/no-transaction.png'),
  linkLabelPrefix: 'Learn more about',
  linkTarget: '_blank',
  onClickTrackLink: () => {},
};

export default NoDataAndLoading;
